export default function ImageFile(baseFilename,url,file = null){
    
    const fileLoadTime = new Date().getTime();

    return{
        baseFilename: baseFilename,
        file: file,
        filename: file ? file.name : null,
        url: url,
        key: baseFilename.concat(' ',fileLoadTime),
        isLocal: file ? true : false
    }
    
}
